export const API_CONFIG = {
  /**
   * Timeout da requisição em milissegundos
   * Padrão: 30 segundos
   */
  timeout: 30000,

  /**
   * Configuração de tentativas de nova requisição em caso de falha
   */
  retry: {
    /**
     * Número máximo de tentativas
     */
    maxAttempts: 3,

    /**
     * Intervalo entre tentativas em milissegundos
     */
    delay: 1000,

    /**
     * Multiplicador para backoff exponencial
     * delay = delay * backoffMultiplier^attemptNumber
     */
    backoffMultiplier: 2,

    /**
     * Códigos de status HTTP que devem disparar nova tentativa
     */
    retryableStatuses: [408, 429, 500, 502, 503, 504],

    /**
     * Métodos HTTP considerados seguros para nova tentativa
     */
    retryableMethods: ['GET', 'HEAD', 'OPTIONS', 'PUT', 'DELETE'],
  },

  /**
   * Configuração da fila de requisições durante refresh de token
   */
  queue: {
    /**
     * Número máximo de requisições na fila durante o refresh
     */
    maxSize: 50,

    /**
     * Timeout das requisições na fila em milissegundos
     */
    timeout: 60000,
  },
} as const;

/**
 * Configuração de Feature Flags
 * Ative/desative funcionalidades sem alterar o código
 */
export const FEATURE_FLAGS = {
  /**
   * Ativar lógica de nova tentativa de requisição
   */
  enableRetry: true,

  /**
   * Ativar logs detalhados de erro
   */
  enableErrorLogging: true,

  /**
   * Ativar monitoramento de performance
   */
  enablePerformanceMonitoring: false,

  /**
   * Ativar logs de interceptadores de requisição/resposta
   */
  enableInterceptorLogging: false,

  /**
   * Ativar rastreamento de analytics
   */
  enableAnalytics: false,
} as const;

/**
 * Configuração de Logs
 */
export const LOGGING_CONFIG = {
  /**
   * Níveis de log: 'debug' | 'info' | 'warn' | 'error' | 'none'
   */
  level: 'info' as 'debug' | 'info' | 'warn' | 'error' | 'none',

  /**
   * Ativar logs no console
   */
  enableConsole: true,

  /**
   * Ativar rastreamento remoto de erros (ex: Sentry)
   */
  enableRemoteTracking: false,

  /**
   * DSN para rastreamento remoto (configurar nos arquivos de ambiente)
   */
  remoteDSN: '',
} as const;

/**
 * Configuração de Cache
 */
export const CACHE_CONFIG = {
  /**
   * TTL padrão do cache em milissegundos
   */
  defaultTTL: 5 * 60 * 1000, // 5 minutos

  /**
   * Tamanho máximo do cache (número de entradas)
   */
  maxSize: 100,

  /**
   * Ativar cache para requisições GET
   */
  enableHttpCache: false,
} as const;

/**
 * Configuração de Segurança
 */
export const SECURITY_CONFIG = {
  /**
   * Buffer de expiração do token em segundos
   * Faz o refresh do token essa quantidade de segundos antes da expiração real
   */
  tokenExpirationBuffer: 60,

  /**
   * Tempo máximo de sessão inativa em milissegundos
   */
  maxIdleTime: 30 * 60 * 1000, // 30 minutos

  /**
   * Ativar proteção CSRF
   */
  enableCSRF: true,

  /**
   * Nome do header do token CSRF
   */
  csrfHeaderName: 'X-CSRF-Token',

  /**
   * Nome da meta tag do token CSRF
   */
  csrfMetaTagName: 'csrf-token',
} as const;
